(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dhgate-transaction-staticv2"] = factory();
	else
		root["dhgate-transaction-staticv2"] = factory();
})(this, function() {
return 